module.exports = __webpack_public_path__ + "img/marketplace-delete.6e2e44d.svg";